import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static override targets = ['nav']

  static override values = { isSticky: String }

  declare readonly navTarget: HTMLInputElement
  declare readonly isStickyValue: string
  override connect() {
    // @ts-ignore
    const brand = window.__BRAND__
    if (brand === 'confused') {
      document.getElementById('app')!.style.marginTop = `0`
    }
    if (this.navTarget && this.isStickyValue === 'true') {
      window.addEventListener('scroll', this.navScroll)
    } else {
      window.removeEventListener('scroll', this.navScroll)
    }
  }

  constructor(props: any) {
    super(props)
    this.navScroll = this.navScroll.bind(this)
  }

  navScroll() {
    // @ts-ignore
    const brand = window.__BRAND__
    const windowWidth = window.innerWidth
    const width = window.innerWidth - (brand === 'money' ? 1186 : 1168)

    const navHeight = this.navTarget.getBoundingClientRect().height
    if (windowWidth < 769) {
      if (window.scrollY > 0) {
        this.navTarget?.classList.add('PpcNav__sticky')
        document.getElementById('app')!.style.paddingTop = `${navHeight}px`

        this.navTarget.style.paddingLeft = `${width > 0 ? width / 2 : 16}px`
        this.navTarget.style.paddingRight = `${width > 0 ? width / 2 : 16}px`
        if (brand === 'money') {
          this.navTarget.style.width = '-webkit-fill-available'
        }
      } else {
        this.navTarget?.classList.remove('PpcNav__sticky')
        this.navTarget.style.paddingLeft = '0'
        this.navTarget.style.paddingRight = '0'
        document.getElementById('app')!.style.paddingTop = `0`
      }
    }
  }
}
